<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template lang="html">
  <div class="centerx">
    <vs-popup
        class="upload-producer-commissions"
        title="Upload Producer Commissions"
        :active="visible"
        button-close-hidden
    >
      <vue-element-loading v-if="modalLoading" :active="modalLoading"></vue-element-loading>

      <vue-form-generator
          v-if="!modalLoading"
          ref="form"
          :model="model"
          :schema="schema"
      />

      <div class="vx-col w-full text-right my-3">
        <vs-button
            class="mr-4 mt-2"
            @click="uploadTemplate"
            color="light"
            :disabled="modalLoading || !model.File"
        >
          Upload
        </vs-button>
        <vs-button class="ml-3" @click="cancel">
          Cancel
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>

import FormModelMixin from "@/components/mixins/FormModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import Vue from 'vue';
import { validateFileType } from '../../../validation/Vfg/resources';

const selectOptions = {
  showLabels: false,
  hideSelected: true,
  key: "id",
  trackBy: "id",
  label: "name",
};

export default {
  props: {
    visible: {
      // using visible instead of value (v-model) because of a conflict with FormModelMixin
      type: Boolean,
      default: false
    },
  },
  mixins: [FormModelMixin, NotificationMixin],
  data () {
    return {
      modalLoading: false,
      model: {
        File: null,
      },
      schema: {
        groups: [
          {
            styleClasses: "vx-row w-full",
            fields: [
              {
                type: "upload",
                inputType: "file",
                styleClasses: "vx-col w-full",
                label: "Producer Commission Template",
                model: "File",
                placeholder: "",
                required: true,
                validator: [() => {
                  if (this.model.hasOwnProperty("File") && this.model.File) {
                    return true;
                  }

                  return 'This field is required';
                }, validateFileType(['csv'])],
                onChanged: (model, schema, event, instance) => {
                  this.model.File = instance.$el.children[0].files[0];
                },
                files: true,
              },
            ]
          },
        ],
      },
    }
  },
  methods: {
    getParams() {
      const params = new FormData();
      params.set('_method', 'post');

      for (const field in this.model) {
        params.set(field, this.model[field]);
      }

      return params;
    },
    cancel() {
      this.$emit('cancel');
    },
    async uploadTemplate() {
      this.modalLoading = true;

      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');

        this.modalLoading = false;
        return false;
      }

      try {
        const params = this.getParams();

        await this.$api.clientMap.uploadTemplate(params);
        this.notifySuccess('Template updated');
      } catch (e) {
        const response = e.response;
        let errorMessage = 'An error occurred'

        if (response.data.errors) {
          errorMessage = response.data.errors.File[0];
        }

        if (response.data.message.errors) {
          errorMessage = response.data.message.errors.join('<br>');
        }

        this.notifyError(errorMessage);
      } finally {
        this.modalLoading = false;
        this.model.File = null;
        this.cancel();
      }
    }
  },
}

</script>

<style lang="scss">
.vs-popup--content {
  overflow: visible;
}
</style>
